import img1 from '../images/avatar/avt-1.jpg'
import img2 from '../images/avatar/avt-2.jpg'
import img3 from '../images/avatar/avt-3.jpg'
import img4 from '../images/avatar/avt-4.jpg'
import img5 from '../images/avatar/avt-5.jpg'
import img6 from '../images/avatar/avt-6.jpg'
const dataBestSeller = [
    {
        img: img1,
        name: 'Jason M. Stalls',
        price: '523.7 ETH',
    },
    {
        img: img2,
        name: 'Frank F. Chan',
        price: '523.7 ETH',
    },
    {
        img: img3,
        name: 'Robert George',
        price: '523.7 ETH',
    },
    {
        img: img4,
        name: 'Frank N. Glisson',
        price: '523.7 ETH',
    },
    {
        img: img5,
        name: 'Michel ZonaS',
        price: '523.7 ETH',
    },
    {
        img: img6,
        name: 'Mizanur Mango',
        price: '523.7 ETH',
    },
    {
        img: img1,
        name: 'Jason M. Stalls',
        price: '523.7 ETH',
    },
    {
        img: img2,
        name: 'Frank F. Chan',
        price: '523.7 ETH',
    },
    {
        img: img3,
        name: 'Robert George',
        price: '523.7 ETH',
    }

]

export default dataBestSeller;